// extracted by mini-css-extract-plugin
module.exports = {"customButton":"style_customButton__265ZT","text":"style_text__MOihs","loader":"style_loader__TVhFK","spin":"style_spin__174ND"};